import React, { Component } from 'react'
import Select from 'react-select'

class WhatsAppGroup extends Component {
    constructor() {
        super()
        this.state = {
            WhatsAppGroupList:[ {"label":"YES","value":"YES"},{"label":"NO","value":"NO"},{"label":"NA","value":"NA"}]
        }
        this.isComponentStillMounted = true
    }

   

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    

    render() {
       return (
            <div>
                <Select
                value={this.props.selectedValue}
                options={this.state.WhatsAppGroupList}
                placeholder="Select Options"
                onChange={(e) => { (e) ? this.props.whatsAppGroupChange(e) : this.props.whatsAppGroupChange([])}}
                />
            </div>
        )
    }
}

export default WhatsAppGroup


// WEBPACK FOOTER //
// ./src/modules/Teams/Components/DropDowns/WhatsAppGroup.js